import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { get } from 'lodash'
import { MyProfile } from 'containers/misc'
import {
  HeaderDashboard,
  DashboardGrid as Grid,
  BurgerMenu
} from 'components/layout'
import { ParticipantsList } from 'components/sections/assessor'
import { meta } from 'helpers/decorators'
import { apiAssessors, apiDashboard } from 'helpers/decorators/api'
import { renderRoutes } from 'react-router-config'
import config from 'config'
import MODALS from 'constants/layout/modals'
import { FilterParticipants } from 'containers/filters'
import { AffiliationsOverviewModal, WWCStatusModal } from '../../../components/modals'
import AssessorEmptyDashboard from '../../../components/layout/AssessorEmptyDashboard/AssessorEmptyDashboard'

@apiDashboard.apiPersons({
  loadProfile: true,
  isAssessor: true
})
@apiAssessors({
  loadParticipants: true
})
@connect(
  ({ api }) => ({
    participants: api.assessor.participants
  }),
  { push }
)

@meta({ title: 'Assessor Dashboard', intlKey: 'route.assessor_dashboard' })
class AssessorDashboard extends Component {
  static propTypes = {
    location: PropTypes.object,
    route: PropTypes.object,
    awards: PropTypes.object,
    assessor: PropTypes.object,
    participants: PropTypes.object,
    push: PropTypes.func
  }

  render() {
    const { location, route, awards, params, participants, push, children, match } = this.props

    const indexRoute = `${config.publicPath}/assessor`

    const showWelcomePage = get(match, 'path') === indexRoute
      && get(match, 'isExact') === true

    return (
      <div>
        <BurgerMenu routeParams={params} isAssessor />

        <HeaderDashboard indexRoute={indexRoute} isAssessor />

        <Grid.Wrap>
          {/* if location is index route, it means that we want to see the Activity list. */}
          <Grid.Left isSmDetail={get(location, 'pathname') !== indexRoute}>

            <FilterParticipants />
            <ParticipantsList participants={participants} push={push} />
          </Grid.Left>

          <Grid.Right
            isAssessor
            isFetchingAward={get(awards, 'loading', false)}
          >
            {route && renderRoutes(route.routes, {
              awards
            })}

            {!children && showWelcomePage && (
              <AssessorEmptyDashboard
                isLoading={get(awards, 'loading', false)}
              />
            )}
          </Grid.Right>
        </Grid.Wrap>

        <MyProfile isAssessor />

        <AffiliationsOverviewModal modalId={MODALS.AFFILIATIONS_OVERVIEW} />
        <WWCStatusModal modalId={MODALS.WWC_STATUS} />
      </div>
    )
  }
}

export default AssessorDashboard
